/* src/app/modules/subscription/cancel-account-dialog/cancel-account-dialog.component.css */
.cancel-dialog-container {
  padding: 0;
  max-width: 580px;
}
.cancel-dialog-content {
  padding: 32px 28px 28px;
  text-align: center;
  background:
    linear-gradient(
      135deg,
      #fefefe 0%,
      #ffffff 100%);
}
.cancel-icon-wrapper {
  margin-bottom: 16px;
}
.cancel-icon {
  font-size: 56px;
  line-height: 1;
  animation: fadeInScale 0.4s ease-out;
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.cancel-title {
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
}
.cancel-subtitle {
  margin: 0 0 18px 0;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  line-height: 1.5;
}
.cancel-info-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 18px;
  background:
    linear-gradient(
      135deg,
      #fff8e1 0%,
      #fff9e7 100%);
  border-radius: 10px;
  border: 1px solid #ffe082;
  text-align: left;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.08);
}
.info-icon {
  font-size: 24px;
  flex-shrink: 0;
  line-height: 1.5;
}
.info-content strong {
  display: block;
  color: #1a1a1a;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 600;
}
.info-content p {
  margin: 0;
  color: #555555;
  font-size: 13px;
  line-height: 1.5;
}
.cancel-benefits {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 10px;
  border: 1px solid #eeeeee;
  text-align: left;
}
.benefits-title {
  margin: 0 0 14px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}
.benefit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #444444;
  font-size: 14px;
  line-height: 1.5;
}
.benefit-icon {
  color: #4caf50;
  font-weight: bold;
  flex-shrink: 0;
  font-size: 16px;
}
.cancel-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;
}
.btn {
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-icon {
  font-size: 18px;
}
.btn-stay {
  background:
    linear-gradient(
      135deg,
      #d48f00,
      #b8790a);
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(212, 143, 0, 0.35);
}
.btn-stay:hover {
  background:
    linear-gradient(
      135deg,
      #f7a820,
      #e89311);
  box-shadow: 0 6px 20px rgba(243, 155, 19, 0.45);
  transform: translateY(-2px);
}
.btn-stay:active {
  transform: translateY(0);
  box-shadow: 0 3px 12px rgba(243, 155, 19, 0.3);
}
.btn-cancel {
  background: transparent;
  border: 1px solid #d0d0d0;
  color: #666666;
  box-shadow: none;
}
.btn-cancel:hover {
  background-color: #fafafa;
  border-color: #b0b0b0;
  color: #444444;
}
.cancel-footer {
  margin: 0;
  font-size: 13px;
  color: #888888;
  text-align: center;
}
.support-link {
  color: var(--cf-brand-dark);
  text-decoration: none;
  font-weight: 600;
}
.support-link:hover {
  text-decoration: underline;
}
@media (max-width: 500px) {
  .cancel-dialog-container {
    min-width: 100%;
  }
  .cancel-dialog-content {
    padding: 32px 24px 24px;
  }
  .cancel-title {
    font-size: 22px;
  }
}
/*# sourceMappingURL=cancel-account-dialog.component.css.map */
